import React from "react";
import { styled } from "@mui/system";
import Switch from "@mui/material/Switch";

const CustomSwitch = styled(Switch)(({ theme }) => ({
  width: 40,
  height: 20,
  padding: 0,
  margin: 10,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 18,
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 3,
    paddingTop: 2,
    "&.Mui-checked": {
      transform: "translateX(18px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#ed6c02",
        border: "none",
      },
      "& .MuiSwitch-thumb": {
        backgroundColor: "#fff",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: "#ed6c02",
    width: 15,
    height: 15,
    borderRadius: "50%",
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
  },
  "& .MuiSwitch-track": {
    borderRadius: 20 / 2,
    opacity: 1,
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    boxSizing: "border-box",
  },
}));

const KMKSwitch = (props) => <CustomSwitch {...props} />;

export default KMKSwitch;
